module.exports = __webpack_public_path__ + "static/media/sin_cargos.46a499cf.png";